<template>
  <div id="app">
    <b-container>
      <b-card>
        <b-card-text>
          <b-row>
            <b-col cols="6" class="image">
              <img src="@/assets/info_graphic.svg" />
              <strong>Squalo Rendimentos</strong>
              <small>Os dados são calculados para auxiliar o enquadramento dos seus impostos no Fator-R</small>
              <small>Levamos em consideração apenas impostos! Não esqueca das suas outras despesas empresariais.</small>
            </b-col>
            <b-col cols="6" class="wizard">
              <Wizard />
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import Wizard from "./components/Wizard";
export default {
  name: "Rendimentos",
  components: { Wizard }
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=Ubuntu:400,700&display=swap");

#app {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-family: "Ubuntu", sans-serif;

  .card {
    border-radius: 0;
    box-shadow: 0px 0px 40px 3px #000;
    height: 85vh;
    max-height: 600px;
    border: 0;

    .card-body {
      height: 100%;
      padding: 0;

      .card-text {
        height: 100%;
        padding: 0;

        .row {
          height: 100%;
          margin: 0;

          .image {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            height: 100%;

            background: rgb(65, 76, 220);
            background: linear-gradient(
              180deg,
              rgba(65, 76, 220, 1) 0%,
              rgba(35, 38, 115, 1) 100%
            );

            strong {
              margin-top: 20px;
              font-size: 30px;
              color: #ffc400;
            }
            small {
              margin-top: 10px;
              width: 80%;
              text-align: justify;
              color: #ddd;
            }
          }

          .wizard {
            padding: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;

            height: 100%;
          }
        }
      }
    }
  }
}
</style>
